import { INPUT_TYPES } from '../../config/constants';

export const handleFormSubmit = (inputWithProps) => {
    let hasValidationErrors = false;
    let passwordItem;
    let useDefaultPass;
    let filesForUpload = [];
    const result = [];

    for (const item of inputWithProps) {
        if ('_value' in item[1]) {
            if ('_hasValidationErrors' in item[1] && item[1]._hasValidationErrors) {
                hasValidationErrors = true;
                break;
            }

            if (item[1].type === INPUT_TYPES.FILE_PICKER) {
                filesForUpload = item[1]._value;
                continue;
            }

            if (item[1].type === INPUT_TYPES.PASSWORD) {
                passwordItem = item[1]._value;
                useDefaultPass = item[1].useDefaultPass;

                if (useDefaultPass) {
                    passwordItem = getPasswordFromConfig();
                }

                continue;
            }

            const itemConfig = {
                label: item[1].label,
                value: item[1]._value,
                type: item[1].type,
                id: item[0]
            };

            if (item[1].type === INPUT_TYPES.REGISTRATION) {
                itemConfig['subType'] = item[1].subType;
            }

            result.push(itemConfig);
        }
    }

    return {
        result,
        filesForUpload,
        passwordItem,
        hasValidationErrors,
        useDefaultPass
    }
}

export const getPasswordFromConfig = () => {
    let config = window.RESULT_FORM_PAGE_CONFIG.builderConfig.inputs;

    for (let item of config) {
        if (item.type === 'password') {
            return item.value;
        }
    }

    return false;

}

export const mapSubmitData = ({ result, filesForUpload, formId }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    return {
        formId,
        isFromDownloader: parseInt(urlParams.get('downloader')),
        files: urlParams.get('files'),
        url: urlParams.get('referer'),
        email,
        result,
        filesForUpload,
        autoDownloading: !email ? 1 : 0,
        sendEmail: email ? 1 : 0,
    }
}
